export const GET_ZONES_LIST = "GET_ZONES_LIST";
export const GET_SHIFTS_LIST = "GET_SHIFTS_LIST";
export const GET_SHIFT = "GET_SHIFT";
export const GET_MAINTANANCE_CATEGORIES = "GET_MAINTANANCE_CATEGORIES";
export const GET_SP_TECHNICIANS = "GET_SP_TECHNICIANS";
export const GET_OPERATING_HOURS = "GET_OPERATING_HOURS";

export const SELECT_COMPANY = 'SELECT_COMPANY';
export const FETCH_PROVIDERS_SUCCESS = 'FETCH_PROVIDERS_SUCCESS';
export const FETCH_CENTERS_SUCCESS = 'FETCH_CENTERS_SUCCESS';

export const SET_PROVIDERS = 'SET_PROVIDERS';
export const SET_CENTER = 'SET_CENTER';
export const RESET_CENTERS = 'RESET_CENTERS';

export const GET_HOLIDAYS = 'GET_HOLIDAYS';



